import React, { useState, useEffect, useRef } from "react";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import config from "../config/configValues";
import "react-step-progress-bar/styles.css";
import { ProgressBar } from "react-step-progress-bar";
import { useNavigate } from 'react-router-dom';
import MarathTypingHelper from "./MarathiTypingHelper";
import { findDifferenceIndex, compareStrings } from '../config/stringUtils';

const Steps = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState("step1");
    const stepsObject = config.stepsObject;
    const steps = ["step1", "step2", "step3"]
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [inputBoxPosition, setInputBoxPosition] = useState({ top: 0, left: 0 });
    const [activeInput, setActiveInput] = useState({});
    const lastModifiedInputRef = useRef(null);
    // const [glow, setGlow] = useState(true);

    // useEffect(() => {
    //     // After component mounts, add glow effect
    //     setGlow(true);

    //     // Remove glow effect after 5 seconds
    //     const timeoutId = setTimeout(() => {
    //         setGlow(false);
    //     }, 5000);

    //     // Clean up the timeout to avoid memory leaks
    //     return () => clearTimeout(timeoutId);
    // }, []);

    const nextStep = () => {
        const currentIndex = steps.indexOf(step);
        if (currentIndex < steps.length - 1) {
            setStep(steps[currentIndex + 1]);
        }
    };
    const prevStep = () => {

        const currentIndex = steps.indexOf(step);
        if (currentIndex > 0) {
            setStep(steps[currentIndex - 1]);
        }
    };

    const [formData, setFormData] = useState(config.formData);

    const handleSubmit = (e) => {
        navigate('/template', { state: { formData: formData } });
    }

    const handleLabelChange = (e, index) => {

        console.log("this is test ", index);
        const inputBox = e.target;
        const updatedFormData = { ...formData };
        lastModifiedInputRef.current = inputBox;

        const rect = inputBox.getBoundingClientRect();
        console.log("rect.top " + rect.bottom + " rect.left: " + rect.left)

        setInputBoxPosition({
            top: rect.bottom + window.scrollY,
            left: rect.left + window.scrollX,
        });

        let currentIndex = findDifferenceIndex(updatedFormData[step][index].labelTitle, inputBox.value)

        let compairResult = compareStrings(updatedFormData[step][index].labelTitle, inputBox.value)

        let inputValue = { ...activeInput, activeIndex: currentIndex }

        setActiveInput(inputValue);
        if (compairResult) {
            updatedFormData[step][index].labelTitle = inputBox.value || "";
            setFormData(updatedFormData);
        }
    };

    const handleChange = (e, index) => {
        const updatedFormData = { ...formData };
        const inputBox = e.target;
        const inputObject = updatedFormData[step][index]

        console.log("value ", inputBox.value, " index ", index)

        if (inputObject.type === "dropdown" || inputObject.dataType !== "text") {
            updatedFormData[step][index].value = inputBox.value;
            setFormData(updatedFormData);
        } else {

            const rect = inputBox.getBoundingClientRect();
            setInputBoxPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX
            });

            let currentIndex = findDifferenceIndex(inputObject.value, inputBox.value)
            let compairResult = compareStrings(inputObject.value, inputBox.value)

            console.log("currentIndex : " + currentIndex + " :compairResult " + compairResult + " value" + inputBox.value)

            let inputValue = { ...activeInput, activeIndex: currentIndex }

            setActiveInput(inputValue);

            if (compairResult) {
                updatedFormData[step][index].value = inputBox.value || '';
                setFormData(updatedFormData);
            }
            lastModifiedInputRef.current = inputBox;
        }
    };

    const updateModalValue = (value) => {
        const updatedFormData = { ...formData };
        const { index, activeIndex, inputType } = activeInput;

        if (inputType === "value") {
            const currentValue = updatedFormData[step][index].value || "";

            // Insert the value at the specified character position (activeIndex)
            const newValue = currentValue.slice(0, activeIndex) + value + currentValue.slice(activeIndex);

            updatedFormData[step][index].value = newValue;
        } else if (inputType === "labelTitle") {
            const currentLabelTitle = updatedFormData[step][index].labelTitle || "";

            // Insert the value at the specified character position (activeIndex)
            const newLabelTitle = currentLabelTitle.slice(0, activeIndex) + value + currentLabelTitle.slice(activeIndex);

            updatedFormData[step][index].labelTitle = newLabelTitle;
        }

        setFormData(updatedFormData);
        lastModifiedInputRef.current.focus();
    }

    const handleImageUpdate = (filename) => {
        setFormData({ ...formData, image: filename });
    }

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleKeyUp = (e, inputValue) => {
        const isAlphabeticChange = /^[a-zA-Z]$/.test(e.key);

        if (isAlphabeticChange) {
            setActiveInput({ ...inputValue, activeIndex: activeInput.activeIndex });
            setIsModalOpen(true);
        }
    };
    const changeDisplayToTrue = (index) => {
        console.log("changeDisplayToTrue index : ", index, "  : ")
        const updatedFormData = { ...formData };
        updatedFormData[step][index].display = !updatedFormData[step][index].display
        console.log("changeDisplayToTrue index : ", index, "  : ", updatedFormData[step][index])
        setFormData(updatedFormData);
    };
    return (
        <section className="ajit-slideshow slick-dotted">
            <div className="container" style={{ backgroundColor: "transparent" }}>
                <div className="col-lg-12">
                    <div className="card border-0" style={{ backgroundColor: "transparent" }}>
                        {/* <div className="card-header border-0">

                                <h3 className="card-title text-center">|| ओम गणपतेय नमः ||</h3>
                            </div> */}
                        <div className="card-body pt-0 text-center">
                            <img src="./ganpati.png" alt="Rounded ganpati" className="rounded mx-auto d-block" width="100" height="110" />
                            <p>|| ओम गणपतेय नमः ||</p>
                        </div>
                    </div>
                </div>

            <h4>परिचय पत्रक (बायोडाटा)</h4>
            <ProgressBar percent={100 * (steps.indexOf(step) + 1) / steps.length} />
            <form className="mt-4" onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="col-lg-12" >
                    <div className="card" style={{ marginBottom: 50, background: "rgba(172, 166, 173, 0.5)" }}>
                        <div className="card-header text-center" style={{ background: "rgba(252, 247, 252, 0.3)" }}>
                            <div className='row'>
                                <div className="col-4 offset-md-4">
                                    <h5 className="card-title">{stepsObject[step]}</h5>
                                    {/* प्राथमिक माहिती */}
                                </div>
                                <div className="col-4">
                                    <select className="form-control" onChange={(e) => changeDisplayToTrue(e.target.value)} >
                                        <option>अधिकची माहिती भरा</option>
                                        {formData[step].map((object, index) => (
                                            !object.display && (
                                                <option key={index} value={index}>
                                                    {object.labelTitle}
                                                </option>
                                            )
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <Step1
                            className={step === "step1" ? "active-step" : "inactive-step"}
                            nextStep={nextStep}
                            handleLabelChange={handleLabelChange}
                            formData={formData.step1}
                            handleChange={handleChange}
                            handleKeyUp={handleKeyUp}
                            changeDisplayToTrue={changeDisplayToTrue}
                        />

                            <Step2
                                className={step === "step2" ? "active-step" : "inactive-step"}
                                nextStep={nextStep}
                                handleLabelChange={handleLabelChange}
                                formData={formData.step2}
                                handleChange={handleChange}
                                handleImageUpdate={handleImageUpdate}
                                prevStep={prevStep}
                                handleKeyUp={handleKeyUp}
                                changeDisplayToTrue={changeDisplayToTrue} />

                            <Step3
                                className={step === "step3" ? "active-step" : "inactive-step"}
                                prevStep={prevStep}
                                handleChange={handleChange}
                                handleLabelChange={handleLabelChange}
                                formData={formData.step3}
                                handleKeyUp={handleKeyUp}
                                handleSubmit={handleSubmit}
                                changeDisplayToTrue={changeDisplayToTrue}
                            />

                        </div>
                    </div>
                    {isModalOpen &&
                        <MarathTypingHelper
                            position={inputBoxPosition}
                            isOpen={isModalOpen}
                            onRequestClose={closeModal}
                            updateModalValue={updateModalValue}
                            activeInput={activeInput} />}
                </form>

            </div>
        </section>
    );
}
export default Steps;